import styled from 'styled-components';
import React, { useEffect } from 'react';
import { Close as CloseIcon } from '@material-ui/icons';
import { useDispatch, useSelector } from 'react-redux';
import { Dialog as MaterialDialog, Grid, Portal } from '@material-ui/core';
import { palette } from '@dev/ee-components';
import { useHistoryBackActionContext } from '@/services/hooks/useHistoryBackAction';
import { SetToastPortalWrapper } from '@/store/toast/actions';
import { CloseGallery, getCheckoutCreatorGalleryOpenStore } from '@/store/checkoutCreator/actions';
import { GalleryTemplateList } from './components/GalleryTemplateList';

const CloseIconContainer = styled.div`
    width: 100%;
    height: 68px;
    svg {
        fill: #718096;
        top: 24px;
        right: 24px;
        position: absolute;
        cursor: pointer;
    }
`;

const Overlay = styled.div`
    background: ${palette.snow[1]};
    height: max-content;
    min-height: 100vh;

    .MuiContainer-root {
        padding-top: 60px;
    }
`;

export const TemplatesGallery = (): JSX.Element => {
    const dispatch = useDispatch();
    const isGalleryOpen = useSelector(getCheckoutCreatorGalleryOpenStore);
    const historyBackAction = useHistoryBackActionContext();

    useEffect(() => {
        if (!isGalleryOpen) {
            return;
        }
        dispatch(SetToastPortalWrapper(true));
        historyBackAction?.pushBackCallback(closeGallery)

        return () => {
            dispatch(SetToastPortalWrapper(false));
        };
    }, [isGalleryOpen]);

    const closeGallery = (): boolean => {
        dispatch(CloseGallery());
        return true;
    };
    
    const onClose = (): void => {
        historyBackAction.popBackCallback();
        closeGallery();
    };

    // scroll container have to be added as query selector string (DOM node mentioned in react-lazyload documentation doesn't work)
    const galleryScrollContainerId = 'galleryScrollContainer';

    return (
        <Portal>
            <MaterialDialog open={isGalleryOpen} fullScreen scroll='body' id={galleryScrollContainerId}>
                <Overlay>
                    <CloseIconContainer>
                        <CloseIcon fontSize='large' onClick={onClose} />
                    </CloseIconContainer>
                    <Grid container justifyContent="center" style={{ padding: '0px 16px' }}>
                        <Grid item xs={12} sm={12} style={{ maxWidth: 1170, paddingBottom: 16 }}>
                            <GalleryTemplateList />
                        </Grid>
                    </Grid>
                </Overlay>
            </MaterialDialog>
        </Portal>
    );
};
